import createPersistedStata from "vuex-persistedstate";
import { createStore } from "vuex";
import * as echarts from "echarts";
export default createStore({
  state: {
    token: "",
    echarts: echarts,
    mainTabs: [
      { label: "首页", name: "001", show: true, url: "/index", close: false },
    ],
    activeTab: "001",
    permission: "",
    names: "",
  },
  getters: {},
  mutations: {
    // token
    updataToken(state, payload) {
      state.token = payload;
    },
    // 标签页首
    addTabs(state, payload) {
      state.mainTabs.push(payload);
    },
    changeTab(state, data) {
      state.activeTab = data;
    },
    changeNav(state, data) {
      state.names = data.names;
      state.permission = data.listStr;
    },
  },
  actions: {},
  modules: {},
  plugins: [
    createPersistedStata({
      storage: window.sessionStorage,
    }),
  ],
});
